<div class="parental-gate">
  <form [formGroup]="otpForm" (ngSubmit)="verifyAndContinue()" class="otp-form">
    <mat-card class="verification-card">
      <mat-card-content class="text-center">
        <div *ngIf="!isOtpSent">
          <div class="icon-wrapper shield-bg">
            <img src="assets/icons/parental-gate-icon-lock.svg" alt="parental-gate-lock-icon" class="parental-gate-icon">
          </div>

          <h2 class="mat-h2 card-title">
            {{ 'ParentalGate.Labels.Info1' | translate }}
          </h2>
          <p class="description">
            {{ 'ParentalGate.Labels.Info2' | translate }}
          </p>

          <div class="button-group">
            <button mat-flat-button class="btn-send-otp" (click)="sendCode()">
              <mat-spinner diameter="20" *ngIf="isSendingOtp"></mat-spinner>
              <span *ngIf="!isSendingOtp"> Send Code </span>
            </button>
            <button mat-stroked-button class="btn-cancel" (click)="cancel()">
              <mat-icon class="mini-icon">close</mat-icon> Cancel
            </button>
          </div>
        </div>

        <div *ngIf="isOtpSent">
          <div class="icon-wrapper mail-bg">
            <img src="assets/icons/parental-gate-icon-mail.svg" alt="parental-gate-mail-icon" class="parental-gate-icon">
          </div>

          <h2 class="mat-h2 card-title">{{ 'ParentalGate.Labels.Info3' | translate }}</h2>
          <p class="description">
            {{ 'ParentalGate.Labels.Info4' | translate }}
            <strong class="dark-text">{{ maskEmail(userInfo?.Email) }}</strong
            >{{ 'ParentalGate.Labels.Info5' | translate }}
          </p>

          <div class="otp-container">
            <input
              #otpBox
              class="otp-box"
              *ngFor="let control of otpControls; let i = index"
              maxlength="1"
              [formControlName]="'otp' + (i + 1)"
              (input)="onOtpInput($event, i)"
              (keydown)="onKeyDown($event, i)"
              autocomplete="new-password"
            />
          </div>

          <span class="error" *ngIf="showOtpError">
            {{ 'ParentalGate.Labels.OTPNumError' | translate }}
          </span>

          <div class="meta-row">
            <div class="timer" *ngIf="countdown">
              <img src="assets/icons/parental-gate-check.svg" alt="parental-gate-shield-check-icon" class="mini-icon">
              {{ 'ParentalGate.Labels.OTPExpiry1' | translate }}
              <span class="highlight">{{ countdown }}</span>
              {{ 'ParentalGate.Labels.OTPExpiry2' | translate }}
            </div>
            <div class="timer" *ngIf="!countdown">
              <img src="assets/icons/parental-gate-check.svg" alt="parental-gate-shield-check-icon" class="mini-icon">
              {{ 'ParentalGate.Labels.OTPExpiry4' | translate }}
            </div>
            <div class="resend">
              {{ 'ParentalGate.Labels.OTPExpiry3' | translate }}
              <button
                mat-button
                type="button"
                class="resend-otp-button"
                [disabled]="countdown > 0"
                (click)="resendOtp()"
              >
                {{ 'ParentalGate.Labels.ResendOTP' | translate }}
                <mat-spinner diameter="18" *ngIf="isSendingOtp"  class="resend-btn-spinner"></mat-spinner>
              </button>
            </div>
          </div>

          <button
            mat-flat-button
            type="submit"
            class="btn-verify-otp btn-block"
            [disabled]="!otpForm.valid || isVerifyingOtp"
          >
            <mat-spinner diameter="25" *ngIf="isVerifyingOtp"></mat-spinner>
            <span *ngIf="!isVerifyingOtp">
              <mat-icon class="verify-lock-icon">lock</mat-icon>
              {{ 'ParentalGate.Labels.VerifyOTP' | translate }}
            </span>
          </button>
        </div>
      </mat-card-content>
    </mat-card>
  </form>
</div>
